// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2pUO8","header":"ReportDetails_header__QYFr0","title":"ReportDetails_title__2Skfi","left":"ReportDetails_left__RmRcz"};